import { useMemo } from 'react'
import PartType from '../../constants/PartType'
import { getServiceSku } from '../../constants/ServiceSkuType'
import IInstallationShop from '../../models/IInstallationShop'
import IInstallationShopVehicle from '../../models/IInstallationShopVehicle'
import {
  getAllowedPartForDifm3,
} from '../../utility/allowedPartsForDifm3'
import { useDifm3Context } from '../contexts/difm3.context'
import { PartPriceModel } from '../models/response/PostalCodePriceModel'

const useSuggestedShopForPartV2 = (
  partName: string,
  sku: string,
  partType: PartType,
  vehicle: IInstallationShopVehicle,
) => {
  const { difmState: { suggestedShops } } = useDifm3Context()

  return useMemo<IInstallationShop | null>(() => {
    const allowedPart = getAllowedPartForDifm3(partName)

    if (!suggestedShops || suggestedShops.isLoading || !suggestedShops.installationShop || !allowedPart) {
      return null
    }

    if (!suggestedShops.partPricesV2) {
      return null
    }

    const priceDetails = suggestedShops.partPricesV2?.find((p: PartPriceModel) => p.reference === sku)

    if (!priceDetails) {
      return null
    }
    return {
      ...suggestedShops.installationShop,
      installPrice: priceDetails?.installPrice,
      installPriceMin: priceDetails?.installPriceMin,
      installPriceMax: priceDetails?.installPriceMax,
      nationalAvgCost: priceDetails?.nationalAvgCost || 0,
      requiredOptions: priceDetails?.requiredOptions || [],
      serviceSku: getServiceSku(partName, partType),
      isSelected: false,
      vehicle: {
        ...vehicle,
        acesIds: vehicle?.acesIds || priceDetails?.acesIds,
      },
    } as IInstallationShop
  }, [partName, suggestedShops, partType, vehicle, sku])
}

export default useSuggestedShopForPartV2
